import { getProductIdFromDataset } from "../../components/pdp/utils/pdpUtils";

export const initialPdpState = {
    rates: {},
    item: {},
    addedQty: 0, // will store the qty added in cart
    isRatesLoading: getProductIdFromDataset() ? true : false,
    alternateInventory: [],
    parentLink: ''
};